import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  root: {
    width: '100%',
    boxShadow: 'none',
    '& .MuiTableRow-root': {
      'td.MuiTableCell-root.MuiTableCell-body:nth-child(1)': {
        flex: '1',
        width: '40%',
      },
      '& td.MuiTableCell-root.MuiTableCell-body:nth-child(2)': {
        width: '34%',
        minWidth: '224px',
      },
      '& td.MuiTableCell-root.MuiTableCell-body:nth-child(3)': {
        minWidth: '200px',
      },
      '& td.MuiTableCell-root.MuiTableCell-body:nth-child(4)': {
        width: '10%',
      },
    },
  },
  rightContainer: {
    width: '650px',
  },
  container: {
    maxHeight: '100%',
  },
  drawerFooter: {
    width: '650px',
    padding: '16px',
    display: 'flex',
    position: 'fixed',
    bottom: '0',
    background: '#fff',
    '& .MuiButton-root': {
      marginRight: 8,
    },
  },
  btnContainer: {
    width: '100%',
    padding: '20px',
    position: 'fixed',
    bottom: '0',
    background: '#fff',
    display: 'flex',
  },
  box: {
    height: '64px',
    width: '64px',
    borderRadius: '6px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: '64px',
      height: 'auto',
    },
  },
  firstColumn: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'inherit',
  },
  firstCoulmContent: {
    textAlign: 'start',
    paddingLeft: '16px',
  },
  thirdColumn: {
    height: '20px',
    width: '70px',
    color: '#3E4142',
    fontFamily: 'ProximaNova-Bold',
    fontSize: '8px',
    fontWeight: 'bold',
    letterSpacing: '0.57px',
    lineHeight: '10px',
    textTransform: 'uppercase',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  draft: {
    boxSizing: 'border-box',
    border: '1px solid #E8EBED',
    backgroundColor: '#E8EBED',
  },
  published: {
    boxSizing: 'border-box',
    border: '1px solid #E8EBED',
  },
  title: {
    padding: '16px 24px',
    color: '#12161A',
    fontFamily: 'ProximaNova-Bold',
    fontSize: '16px',
    lineHeight: '20px',
    float: 'left',
  },
  closeBtn: {
    float: 'right',
    paddingTop: '15px',
  },
  titleDiv: {
    width: '100%',
    float: 'left',
  },
  titleWrapper: {
    width: '100%',
    overflow: 'hidden',
    padding: '20px',
    paddingBottom: '0px',
  },
  secondRow: {
    width: '100%',
    overflow: 'hidden',
    padding: '20px',
  },
  typeInput: {
    width: '400px',
  },
  divider: {
    width: '100%',
    overflow: 'hidden',
  },
  attributeTitle: {
    color: '#12161A',
    fontFamily: 'ProximaNova-Semibold',
    fontSize: '17px',
    letterSpacing: '0',
    lineHeight: '24px',
  },
  delBtn: {
    backgroundColor: '#D0021B',
    color: '#FFF',
    height: '40px',
    lineHeight: '3',
    borderRadius: '6px',
    width: '100px',
  },
  saveLegalBtn: {
    height: '40px',
    width: '100px',
    color: '#FFF',
    lineHeight: 3,
    borderRadius: '6px',
    backgroundColor: '#12161A',
  },
  saveLegalBtn1: {
    height: '40px',
    width: '220px',
    color: '#FFF',
    lineHeight: 3,
    borderRadius: '6px',
    backgroundColor: '#12161A',
  },
  text: {
    fontFamily: 'Proxima-Nova-Regular',
    fontSize: '15px',
    fontWeight: 500,
    letterSpacing: '0',
    lineHeight: '20px',
    color: '#909599',
  },
  imgContainer: {
    backgroundColor: '#000 !important',
    padding: '10px !important',
    margin: '0 auto !important',
    maxWidth: '250px',
    height: '125px',
    backgroundSize: 'contain',
  },
  editIcon: {
    width: '36px',
    height: '36px',
    color: '#000000',
    padding: '6px',
  },
});
